import {
  ItemTypeEnum,
  ProductTypeEnum,
  type LayProduct,
  productMaterialCharacteristicsSchema,
  productPreferencesSchema,
  layItemSchema,
  getBaseProductSchema,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { MaterialStep, PreferencesStep, ToothStep } from "./constants";

export type LayStepKey =
  | typeof StepKeysEnum.tooth
  | typeof StepKeysEnum.material
  | typeof StepKeysEnum.preferences;

export const LayWorkflowConfiguration: ProductWorkflowConfiguration<
  LayProduct,
  LayStepKey
> = {
  productType: ProductTypeEnum.lay,
  itemType: ItemTypeEnum.lay,
  steps: [new ToothStep(), new MaterialStep(), new PreferencesStep()],
  teethSelection: TeethSelectionEnum.UNIQUE,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({ itemSchema: layItemSchema }).safeParse(
      product
    ).success;
  },

  getCompletedSteps(product) {
    const completed: LayStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.tooth);
    }

    const isMaterialStepComplete =
      productMaterialCharacteristicsSchema.safeParse(product).success;

    if (product.items?.length && isMaterialStepComplete) {
      completed.push(StepKeysEnum.material);
    }

    const isPreferencesStepComplete =
      productPreferencesSchema.safeParse(product).success;

    if (isPreferencesStepComplete) {
      completed.push(StepKeysEnum.preferences);
    }

    return completed;
  },
};
